import { DropdownField, Input, Icon } from "@evergis/ui";
import styled, { css } from "styled-components";

export const FieldWrapper = styled.div<{ width?: string; withLabel?: boolean }>`
  display: flex;
  height: 2rem;
  box-sizing: border-box;
  width: ${({ width }) => width};
  position: relative;
  margin-top: ${({ withLabel }) => (withLabel ? "1rem" : 0)};

  input,
  ${DropdownField} {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`;

export const FieldPrefix = styled.div`
  user-select: none;
  background: ${({ theme }) => theme.palette.element};
  border: 1px solid ${({ theme }) => theme.palette.elementDeep};
  color: ${({ theme }) => theme.palette.icon};
  padding: 6px 0.5rem;
  height: 100%;
  box-sizing: border-box;
  border-bottom-left-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-right: none;
`;

export const FieldLabel = styled.div`
  position: absolute;
  top: -1rem;
  left: 0.5rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.palette.textSecondary};
`;

export const PathInput = styled(Input)`
  text-overflow: ellipsis;
  direction: rtl;
  unicode-bidi: normal;
  text-align: left;
`;

export const ClickableIcon = styled(Icon)`
  ${({ disabled }) =>
    disabled
      ? ""
      : css`
          pointer-events: all !important;
          cursor: pointer !important;
        `};
`;
